var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 41.4977L21.3564 41.4557L48.326 14.7437C49.3844 13.6853 49.9668 12.2797 49.9668 10.7845C49.9668 9.2893 49.3844 7.8837 48.326 6.8253L43.8852 2.3845C41.7684 0.267699 38.0752 0.278899 35.9752 2.3761L9 29.0937V41.4977ZM39.926 6.3437L44.3752 10.7761L39.9036 15.2057L35.4628 10.7677L39.926 6.3437ZM14.6 31.4289L31.484 14.7045L35.9248 19.1453L19.0436 35.8641L14.6 35.8781V31.4289Z",
    fill: "#0D2D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 52.4H44.8C47.8884 52.4 50.4 49.8884 50.4 46.8V22.5296L44.8 28.1296V46.8H14.4424C14.3696 46.8 14.294 46.828 14.2212 46.828C14.1288 46.828 14.0364 46.8028 13.9412 46.8H5.6V7.6H24.7716L30.3716 2H5.6C2.5116 2 0 4.5116 0 7.6V46.8C0 49.8884 2.5116 52.4 5.6 52.4Z",
    fill: "#0D2D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c9cd79fa6ecdfdd8bbd2fc21fd19bf8c.svg";
export { ForwardRef as ReactComponent };